import { I18n } from 'i18n-js'

export class TranslationAdapter {
  constructor(translations = {}) {
    this.setTranslations(translations)
  }

  setTranslations(translations, culture = 'en-gb') {
    let locale = culture.toLowerCase()
    if (!translations[locale]) {
      locale = 'en-gb'
    }
    this.instance = new I18n(translations, { locale })
  }

  getTranslator() {
    return this.instance
  }
}

export default new TranslationAdapter()
